import React from 'react';
import Box from "@mui/material/Box";
import { ClubREverywhere } from '@rakutenfrance/shared-svg';
import { colorPalette } from '../../../colorPalette';
export const ClubREverywhereLabel = () => {
    return (React.createElement(Box, { sx: {
            boxSizing: 'border-box',
            display: 'inline-flex',
            alignItems: 'center',
            padding: '5px 8px 3px 8px',
            borderRadius: '4px',
            backgroundColor: colorPalette.white,
            border: `1px solid ${colorPalette.gray200}`,
        }, "data-qa": "club-r-everywhere-label" },
        React.createElement(ClubREverywhere, { width: "116px", height: "14px" })));
};
